import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = () => {
  return checkAuth();
};

export const authChildGuard: CanActivateChildFn = () => {
  return checkAuth();
};

const checkAuth = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((isLoggedIn) => {
      if (!isLoggedIn) {
        return router.parseUrl('/login');
      }
      return true;
    }),
  );
};
